import React from "react"
import Skeleton from "@components/Skeleton/Skeleton"
import css from "./DioRxProcessing.scss"

const VerticalDivider = [{ span: 2 }]
const OrderProcessingConfig = [
    { span: 8, height: "300px" },
    { span: 8, height: "65px", classes: "marginTop-48" },
]
const OrderProcessCountConfig = [
    {
        classes: "marginTop-16",
        columns: [
            { span: 1, height: "110px" },
            {
                rows: [
                    { span: 7, height: "21px" },
                    { span: 7, height: "45px", classes: "marginTop-8" },
                    { span: 7, height: "36px", classes: "marginTop-8" },
                ],
            },
        ],
    },
]
function DioRxProcessingSkeleton() {
    return (
        <div className="page-container">
            <div className="container-fluid flex padding-8-0">
                <div className="flexColumn">
                    <div className="widget-container marginBoth-8 flex" style={{ marginTop: "120px" }}>
                        <div className="col-3" />
                        <Skeleton config={OrderProcessingConfig} isComponent></Skeleton>
                        <div className="col-2" />
                    </div>
                </div>
                <Skeleton config={VerticalDivider} isComponent></Skeleton>
                <div className="flexColumn">
                    <div className="widget-container marginBoth-8">
                        <div className={`marginTop-8 flex ${css.rightContainer}`}>
                            <Skeleton config={OrderProcessCountConfig} isComponent></Skeleton>
                        </div>
                    </div>
                </div>
                <div className="col-1" />
            </div>
        </div>
    )
}

export default DioRxProcessingSkeleton
